import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import ExpandableHtml from "../../user_content/expandable_html";

export default GrComponentFactory.createClass({
  displayName: "RecommendationDetails",

  propTypes: {
    message: React.PropTypes.shape(GrPropTypes.truncatedHtml()),
  },

  render() {
    if (this.props.message) {
      return <ExpandableHtml {...this.props.message} />;
    } else {
      return null;
    }
  },

});
